import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, isRef as _isRef, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createSlots as _createSlots, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_2 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_3 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 0,
    class: "caption-normal-text mb-0"
};
const _hoisted_6 = {
    key: 0,
    class: "caption-normal-text mb-0"
};
const _hoisted_7 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_8 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_9 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_10 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_11 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_12 = { key: 1 };
const _hoisted_13 = {
    key: 0,
    class: "body2-text text-black"
};
const _hoisted_14 = { else: "" };
import { computed, onMounted, ref, toRefs, watch, } from 'vue';
import { i18n } from '@/locales';
import { setErrorMessageData, trimTextField, formatDate, validateTextWithHypen, setLimitedByteText, } from '@/utils';
import { setFormData, makeFormDataComputed, handleBlurTrimTextFormData, makeByteLimitedFormDataComputed, } from '@/utils/vueUtils';
import { validationLimitingValue, useOptionList, } from '@/constants';
import { userStatusOptionList } from '@/constants/userManagement';
import { pageTypeList } from '@/constants/userManagement/pageTypeList';
import InputRow from '@/components/Form/InputRow.vue';
import dateFormatType from '@/constants/dateFormatType';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BasicInfo',
    props: {
        inputRowCss: { default: '' },
        lc: { default: '' },
        userPageLc: { default: '' },
        type: { default: '' },
        formData: { default: {} },
        originFormData: { default: {} },
        formRules: { default: {} },
        formRulesLc: { default: '' },
        errorMessageData: { default: {} }
    },
    emits: ["initFormData"],
    setup(__props, { emit: __emit }) {
        // 일반 정보
        const today = formatDate(Date.now(), dateFormatType.DATE);
        const minDate = today;
        const { USER_NAME_MAX_BYTE, USER_ID_MAX_BYTE, USER_PHONE_MAX_LENGTH, PASSWORD_MAX_BYTE, } = validationLimitingValue;
        const emit = __emit;
        const props = __props;
        const { userPageLc, formRulesLc, formData, originFormData, errorMessageData, } = toRefs(props);
        const userNameRef = ref(null);
        const isCheckUserIdExistence = ref(false);
        const userIdRef = ref(null);
        const isSameIdAndPassword = ref(false);
        // 수정페이지일 경우
        const isTypeEdit = ref(false);
        // 등록페이지일 경우
        const isTypeCreate = ref(false);
        // 등록/수정페이지일 경우
        const isTypeEditable = ref(false);
        const isPasswordHidden = ref(true);
        const userPwRef = ref(null);
        const userNameComputed = makeByteLimitedFormDataComputed(formData.value, 'name', USER_NAME_MAX_BYTE, userNameRef);
        const userIdComputed = makeByteLimitedFormDataComputed(formData.value, 'userId', USER_ID_MAX_BYTE, userIdRef);
        const telephoneComputed = makeFormDataComputed(formData.value, 'telephone');
        const useYnComputed = makeFormDataComputed(formData.value, 'useYn');
        const memoComputed = makeFormDataComputed(formData.value, 'memo');
        const hubIdComputed = makeFormDataComputed(formData.value, 'hubId');
        const levelComputed = makeFormDataComputed(formData.value, 'level');
        const isResignationAtUsed = ref(false);
        const formattedResignationAt = computed({
            get() {
                return validateTextWithHypen(formData.value.resignationAt);
            },
            set(value) {
                setFormData(formData.value, 'resignationAt', value);
            },
        });
        // 사용자 관리에서 등록일은 백엔드에서 자동으로 오늘날짜로 생성하므로 조회만 가능.
        const createdAtComputed = computed(() => {
            if (formData.value.createdAt) {
                return formatDate(formData.value.createdAt, dateFormatType.DATE);
            }
            return today;
        });
        const passwordInputType = computed(() => (isPasswordHidden.value ? 'password' : 'text'));
        const passwordInputIcon = computed(() => (isPasswordHidden.value ? 'mdi-eye-off' : 'mdi-eye'));
        const type = computed(() => vuexStore.state.userManagement.userPage.type);
        const userPwComputed = computed({
            get() {
                // 수정시 사용자 PW는 마스킹 6자리 표기만 한다.
                // https://www.notion.so/barogohq/462def1217c54f349f4aab5e06e072cc?pvs=4
                if (isTypeEdit.value) {
                    const tempPw = '123456789!';
                    return tempPw;
                }
                return formData.value.password;
            },
            set(value) {
                const result = setLimitedByteText(value, PASSWORD_MAX_BYTE, userPwRef.value);
                setFormData(formData.value, 'password', result);
            },
        });
        const userDetail = computed(() => vuexStore.state.userManagement.userPage.userDetail);
        const userId = computed(() => vuexStore.getters['user/userId']);
        const userLevel = computed(() => vuexStore.getters['user/userLevel']);
        const getterUserLevelList = computed(() => vuexStore.getters['userManagement/userPage/getterUserLevelList']);
        const getterHubList = computed(() => vuexStore.getters['userManagement/userPage/getterHubList']);
        // 본인 계정인지 여부 (수정시 본인 계정일때만 휴대폰 번호 변경이 가능)
        const isMyAccount = computed(() => {
            if (type.value === pageTypeList.BASIC_INFO.value) {
                return userId.value === formData.value.userId;
            }
            return true;
        });
        const userLevelList = computed(() => getterUserLevelList.value.filter((item) => item.value !== 'ALL'));
        const hubOptionList = computed(() => getterHubList.value);
        /**
         * 로그인한 계정이 수정하려는 계정보다 권한이 높거나 같아야 변경이 가능하다.
         * 하지만 로그인한 계정이 총판마스터 상태는 수정못함.
         * 로그인한 계정이 본인의 상태변경 불가능
         *
         * 참고 노션 (https://www.notion.so/barogohq/462def1217c54f349f4aab5e06e072cc)
         */
        const isSelectable = computed(() => {
            if (isMyAccount.value) {
                return false;
            }
            const res = userLevel.value >= originFormData.value.level;
            return res;
        });
        /**
         * 사용자 상태 옵션 리스트
         */
        const userUseYnTypeList = computed(() => userStatusOptionList.filter((item) => item.value !== 'ALL'));
        // 현재 페이지 타입 (create|basic-info|detail)
        const isType = (selectedType) => selectedType === type.value;
        // 등록일 출력여부 (등록페이지에서 히든)
        const isShowRegistrationDate = isType(pageTypeList.DETAIL.value) || isType(pageTypeList.BASIC_INFO.value);
        // Id와 Password가 동일한지 여부
        const checkIdAndPassword = () => {
            // 동일하다면 api에서 에러 (둘다 미작성시는 제외하기)
            const isSame = formData.value.userId === formData.value.password && formData.value.password !== '';
            isSameIdAndPassword.value = isSame;
            if (isSame) {
                setErrorMessageData(errorMessageData.value, 'isSameIdAndPassword', i18n.t(`${formRulesLc.value}id_password_same_value_error`, {
                    id: i18n.t(`${userPageLc.value}user_id`),
                }));
                return;
            }
            // reset
            setErrorMessageData(errorMessageData.value, 'isSameIdAndPassword', '');
        };
        const inputPlaceHolder = (name) => {
            const locale = i18n.t('common.input_field_placeholder', {
                field: i18n.t(`${userPageLc.value}${name}`),
            });
            return locale;
        };
        const selectPlaceHolder = (name) => {
            const locale = i18n.t('common.select_field_placeholder', {
                field: i18n.t(`${userPageLc.value}${name}`),
            });
            return locale;
        };
        /**
         * 사용자 ID 존재 여부 체크
         */
        const checkUserIdExistence = async () => {
            try {
                const userIdExistence = await vuexStore.dispatch('userManagement/userPage/isUserIdExist', {
                    userId: formData.value.userId,
                });
                isCheckUserIdExistence.value = true;
                // false면 아이디 사용 가능 (같은 아이디 없음)
                if (!userIdExistence) {
                    return;
                }
                setErrorMessageData(errorMessageData.value, 'userIdExistence', i18n.t(`${formRulesLc.value}already_registered_value`, {
                    field: i18n.t(`${userPageLc.value}user_id`),
                }));
            }
            catch (error) {
                isCheckUserIdExistence.value = true;
                console.log('[User Create handleClickCheckUserIdExistence]', error);
                setErrorMessageData(errorMessageData.value, 'userIdExistence', i18n.t(`${formRulesLc.value}unknown_api_error`));
            }
        };
        /**
         * 사용자 ID 존재 여부 초기화
         */
        const resetUserIdExistence = () => {
            isCheckUserIdExistence.value = false;
            setErrorMessageData(errorMessageData.value, 'userIdExistence', '');
        };
        /**
         * 사용자 ID blur 핸들러
         */
        const handleBlurUserIdField = async () => {
            handleBlurTrimTextFormData(formData.value, 'userId', trimTextField(formData.value.userId));
            const isValid = await userIdRef.value.validate();
            if (isValid.length === 0) {
                checkUserIdExistence();
            }
            checkIdAndPassword();
        };
        /**
         * 비밀번호 blur 핸들러
         */
        const handleBlurUserPasswordField = () => {
            checkIdAndPassword();
        };
        /**
         * 비밀번호 핸들러
         */
        const handleClickAppendInnerUserPw = () => {
            isPasswordHidden.value = !isPasswordHidden.value;
        };
        /**
         * 퇴사일 핸들러
         */
        const handleUpdateResignationAt = (value) => {
            formattedResignationAt.value = value;
        };
        onMounted(() => {
            emit('initFormData');
        });
        watch(() => type.value, () => {
            isTypeEdit.value = type.value === pageTypeList.BASIC_INFO.value;
            isTypeCreate.value = type.value === pageTypeList.CREATE.value;
            isTypeEditable.value = isTypeEdit.value || isTypeCreate.value;
        }, {
            immediate: true,
        });
        watch(() => formData.value.userId, () => {
            resetUserIdExistence();
        });
        watch(() => isResignationAtUsed.value, (value) => {
            // 사용 안 함 일경우
            if (!value) {
                setFormData(formData.value, 'resignationAt', null);
                return;
            }
            // 사용 함 && 기존 값 있는 경우엔 기존값이 디폴트
            if (value && originFormData.value.resignationAt) {
                setFormData(formData.value, 'resignationAt', originFormData.value.resignationAt);
            }
            else {
                // 그 외엔 오늘 날짜
                setFormData(formData.value, 'resignationAt', today);
            }
        }, {
            immediate: true,
        });
        watch(() => formData.value.resignationAt, (value) => {
            if (value) {
                isResignationAtUsed.value = true;
                return;
            }
            isResignationAtUsed.value = false;
        });
        return (_ctx, _cache) => {
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.inputRowCss)
            }, [
                _createCommentVNode(" 소속 허브 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}hub_name`),
                    "is-required": isTypeEditable.value
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(userDetail.value.formattedHubName), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_v_autocomplete, {
                                key: 1,
                                "item-title": "text",
                                "item-value": "value",
                                modelValue: _unref(hubIdComputed),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(hubIdComputed) ? (hubIdComputed).value = $event : null)),
                                items: hubOptionList.value,
                                disabled: isTypeEdit.value,
                                filled: isTypeEdit.value,
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                "validate-on": "blur",
                                placeholder: selectPlaceHolder('hub_name'),
                                rules: _ctx.formRules.hubName.value
                            }, null, 8 /* PROPS */, ["modelValue", "items", "disabled", "filled", "placeholder", "rules"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "is-required"]),
                _createCommentVNode(" 사용자 레벨 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}user_level`),
                    "is-required": isTypeEditable.value
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(userDetail.value.formattedLevel), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_v_select, {
                                key: 1,
                                "item-title": "text",
                                "item-value": "value",
                                modelValue: _unref(levelComputed),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(levelComputed) ? (levelComputed).value = $event : null)),
                                items: userLevelList.value,
                                variant: "outlined",
                                density: "compact",
                                disabled: isTypeEdit.value,
                                filled: isTypeEdit.value,
                                "hide-details": "auto",
                                placeholder: selectPlaceHolder('user_level'),
                                rules: _ctx.formRules.level.value
                            }, null, 8 /* PROPS */, ["modelValue", "items", "disabled", "filled", "placeholder", "rules"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "is-required"]),
                _createCommentVNode(" 사용자 ID "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}user_id`),
                    "is-required": isTypeEditable.value
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(userDetail.value.validatedUserId), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_text_field, {
                                    ref_key: "userIdRef",
                                    ref: userIdRef,
                                    modelValue: _unref(userIdComputed),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(userIdComputed) ? (userIdComputed).value = $event : null)),
                                    disabled: isTypeEdit.value,
                                    filled: isTypeEdit.value,
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: inputPlaceHolder('user_id'),
                                    "error-messages": _unref(errorMessageData).userIdExistence,
                                    oninput: "javascript: this.value = this.value.replace(/[^(ㄱ-힣a-zA-Z0-9~!@#$%^&*(){}_+=)]/g, '' );",
                                    rules: _ctx.formRules.userId.value,
                                    onBlur: handleBlurUserIdField
                                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                                    (isCheckUserIdExistence.value)
                                        ? {
                                            name: "append-inner",
                                            fn: _withCtx(() => [
                                                _createCommentVNode(" 같은 아이디 존재할 경우 x 표시 "),
                                                (_unref(errorMessageData).userIdExistence)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "red"
                                                    }, {
                                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                            _createTextVNode(" mdi-close ")
                                                        ])),
                                                        _: 1 /* STABLE */,
                                                        __: [10]
                                                    }))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createCommentVNode(" 같은 아이디 없을 경우 체크 표시 "),
                                                        _createVNode(_component_v_icon, { color: "green" }, {
                                                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                _createTextVNode(" mdi-check ")
                                                            ])),
                                                            _: 1 /* STABLE */,
                                                            __: [11]
                                                        })
                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "disabled", "filled", "placeholder", "error-messages", "rules"]),
                                (isType(_unref(pageTypeList).CREATE.value))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t(`common.id_pattern_hint`)), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "is-required"]),
                _createCommentVNode(" 사용자 PW "),
                (!isType(_unref(pageTypeList).DETAIL.value))
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 0,
                        label: _ctx.$t(`${_unref(userPageLc)}user_pw`),
                        "is-required": isTypeEditable.value
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                ref_key: "userPwRef",
                                ref: userPwRef,
                                modelValue: userPwComputed.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((userPwComputed).value = $event)),
                                disabled: isTypeEdit.value,
                                filled: isTypeEdit.value,
                                autocomplete: "new-password",
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                type: passwordInputType.value,
                                "append-inner-icon": passwordInputIcon.value,
                                placeholder: inputPlaceHolder('user_pw'),
                                oninput: "javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣\\s]/g, '' );",
                                "error-messages": _unref(errorMessageData).isSameIdAndPassword,
                                rules: _ctx.formRules.password.value,
                                "validate-on": "blur",
                                "onClick:appendInner": handleClickAppendInnerUserPw,
                                onBlur: handleBlurUserPasswordField
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "filled", "type", "append-inner-icon", "placeholder", "error-messages", "rules"]),
                            (isType(_unref(pageTypeList).CREATE.value))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t(`common.password_pattern_hint`)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "is-required"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 사용자명 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}user_name`)
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(userDetail.value.validatedName), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 1,
                                ref_key: "userNameRef",
                                ref: userNameRef,
                                modelValue: _unref(userNameComputed),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(userNameComputed) ? (userNameComputed).value = $event : null)),
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                "validate-on": "blur",
                                placeholder: inputPlaceHolder('name'),
                                oninput: "javascript: this.value = this.value.replace(/[^(ㄱ-힣a-zA-Z0-9~!@#$%^&*(){}_+=)]/g, '' );"
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 사용자 휴대폰 번호 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}admin_phone_number`),
                    "is-required": isTypeEditable.value
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(userDetail.value.formattedTelephone), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 1,
                                modelValue: _unref(telephoneComputed),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(telephoneComputed) ? (telephoneComputed).value = $event : null)),
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                "validate-on": "blur",
                                disabled: !isMyAccount.value,
                                filled: !isMyAccount.value,
                                oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                placeholder: inputPlaceHolder('admin_phone_number'),
                                maxlength: _unref(USER_PHONE_MAX_LENGTH),
                                rules: _ctx.formRules.adminPhoneNumber.value
                            }, null, 8 /* PROPS */, ["modelValue", "disabled", "filled", "placeholder", "maxlength", "rules"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label", "is-required"]),
                _createCommentVNode(" 사용자 상태 "),
                (!isType(_unref(pageTypeList).CREATE.value))
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 1,
                        label: _ctx.$t(`${_unref(userPageLc)}user_status`),
                        "is-required": isTypeEditable.value
                    }, {
                        default: _withCtx(() => [
                            (isType(_unref(pageTypeList).DETAIL.value))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(userDetail.value.formattedUseYn), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (isType(_unref(pageTypeList).BASIC_INFO.value))
                                ? (_openBlock(), _createBlock(_component_v_select, {
                                    key: 1,
                                    "item-title": "text",
                                    "item-value": "value",
                                    modelValue: _unref(useYnComputed),
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (_isRef(useYnComputed) ? (useYnComputed).value = $event : null)),
                                    disabled: !isSelectable.value,
                                    filled: !isSelectable.value,
                                    items: userUseYnTypeList.value,
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: inputPlaceHolder('user_status')
                                }, null, 8 /* PROPS */, ["modelValue", "disabled", "filled", "items", "placeholder"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label", "is-required"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 사용자 메모 "),
                _createVNode(InputRow, {
                    label: _ctx.$t(`${_unref(userPageLc)}memo`)
                }, {
                    default: _withCtx(() => [
                        (isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(userDetail.value.validatedMemo), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 1,
                                modelValue: _unref(memoComputed),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (_isRef(memoComputed) ? (memoComputed).value = $event : null)),
                                variant: "outlined",
                                density: "compact",
                                "hide-details": "auto",
                                "validate-on": "blur",
                                placeholder: inputPlaceHolder('memo')
                            }, null, 8 /* PROPS */, ["modelValue", "placeholder"]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _createCommentVNode(" 등록일 "),
                (_unref(isShowRegistrationDate))
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 2,
                        label: _ctx.$t(`${_unref(userPageLc)}registration_date`)
                    }, {
                        default: _withCtx(() => [
                            (isType(_unref(pageTypeList).DETAIL.value))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(userDetail.value.formattedCreatedAt), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: createdAtComputed.value,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((createdAtComputed).value = $event)),
                                        disabled: isTypeEditable.value,
                                        filled: isTypeEditable.value,
                                        "prepend-inner-icon": "mdi-calendar-month",
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto"
                                    }, null, 8 /* PROPS */, ["modelValue", "disabled", "filled"])
                                ]))
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" 퇴사일 "),
                (isType(_unref(pageTypeList).BASIC_INFO.value) || isType(_unref(pageTypeList).DETAIL.value))
                    ? (_openBlock(), _createBlock(InputRow, {
                        key: 3,
                        label: _ctx.$t(`${_unref(userPageLc)}resignation_at`)
                    }, {
                        default: _withCtx(() => [
                            (isType(_unref(pageTypeList).DETAIL.value))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(userDetail.value.formattedResignationAt), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_14, [
                                (isType(_unref(pageTypeList).BASIC_INFO.value))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_v_select, {
                                            "item-title": "label",
                                            "item-value": "value",
                                            modelValue: isResignationAtUsed.value,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((isResignationAtUsed).value = $event)),
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": "auto",
                                            items: _unref(useOptionList),
                                            class: "d-ib va-b resignation-at-used-select"
                                        }, null, 8 /* PROPS */, ["modelValue", "items"]),
                                        _createVNode(_component_vue_datepicker, {
                                            "model-value": formattedResignationAt.value,
                                            disabled: !isResignationAtUsed.value,
                                            position: "left",
                                            "model-type": "yyyy-MM-dd",
                                            format: "yyyy-MM-dd",
                                            "min-date": _unref(minDate),
                                            "onUpdate:modelValue": handleUpdateResignationAt
                                        }, {
                                            "action-row": _withCtx((actionRowProps) => [
                                                _createCommentVNode(" 퇴사일 캘린더 액션 로우 "),
                                                _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(actionRowProps)), null, 16 /* FULL_PROPS */)
                                            ]),
                                            "dp-input": _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    value: formattedResignationAt.value,
                                                    variant: "outlined",
                                                    density: "compact",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    class: "ml-2",
                                                    "bg-color": "white",
                                                    "prepend-inner-icon": "mdi-calendar-month-outline",
                                                    disabled: !isResignationAtUsed.value,
                                                    style: { "width": "140px" }
                                                }, null, 8 /* PROPS */, ["value", "disabled"])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["model-value", "disabled", "min-date"])
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
